import { render } from "./ENPolicyView.vue?vue&type=template&id=2d0b3173"
import script from "./ENPolicyView.vue?vue&type=script&lang=js"
export * from "./ENPolicyView.vue?vue&type=script&lang=js"

import "./ENPolicyView.vue?vue&type=style&index=0&id=2d0b3173&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/Genesii/COLON/wonderful-colon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__